import NotAuthenticated from './NotAuthenticated';
import NotPurchased from './NotPurchased';
import BlockedBySomeone from './BlockedBySomeone';
import { useAppSelector } from 'hooks/redux';
import { enStatus } from 'interface/course';

const BlockedReasonMessage = () => {
  const blockedBy = useAppSelector((state) => state.course.blocked_by);
  return (
    <div aria-label='Campo informativo sobre o bloqueio do acesso ao curso'>
      <NotAuthenticated />
      {blockedBy === enStatus.NOT_PURCHASED && <NotPurchased />}
      {blockedBy === enStatus.BLOCKED && <BlockedBySomeone />}
    </div>
  );
};

export default BlockedReasonMessage;
